import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUsageScorecard as GetUsageScorecardQuery,
    GetUsageScorecard_usageScorecard as UsageScorecard,
} from 'nutshell-graphql-types';

import GET_USAGE_SCORECARD from '../queries/get-usage-scorecard.graphql';

export const useGetUsageScorecard = (): {
    usageScorecard: UsageScorecard | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {data, loading, error} = useQuery<GetUsageScorecardQuery, Record<any, any>>(
        GET_USAGE_SCORECARD,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    const usageScorecard = data ? data.usageScorecard : null;

    return {
        usageScorecard,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
